import React from 'react';
import { Link } from 'react-router-dom';
import AccountHeader from './AccountHeader';
import '../static/css/SettingsPage.css';
import '../static/css/HowTo.css';

// Shared wrapper for every /how-to-* page. Public (no AuthGate) so the pages can be
// read by logged-out visitors AND loaded inside the iOS/Android apps via a webview.
// Add ?embed=1 to the URL (what the mobile webview uses) to strip the website chrome —
// the AccountHeader and "Back" link — since the native app supplies its own nav bar.
function HowToLayout({ title, children }) {
    const isEmbed = new URLSearchParams(window.location.search).get('embed') === '1';
    return (
        <div className={`settings-page${isEmbed ? ' howto-embed' : ''}`}>
            {!isEmbed && <AccountHeader />}
            <div className="settings-page-content howto-content">
                {!isEmbed && <Link to="/home" className="settings-back-link">Back</Link>}
                <h2 className="settings-page-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>{title}</u></h2>
                <div className="howto-card">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default HowToLayout;
